import { Avatar, Box, Typography, Link, Stack } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LaunchIcon from '@mui/icons-material/Launch';
import avatarImage from '../../../images/avatar2.jpeg';

const HomePage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      <Avatar src={avatarImage} alt="Tony Schwartz" sx={{ width: 180, height: 180, mb: 3 }} />

      <Typography variant="h3" sx={{ mb: 4 }}>
        Tony Schwartz
      </Typography>

      <Stack direction="row" spacing={3}>
        <Link
          href="https://github.com/dtonys"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            textDecoration: 'none',
            color: 'inherit',
            '&:hover': { opacity: 0.7 },
          }}
        >
          <GitHubIcon />
          <Typography>GitHub</Typography>
        </Link>

        <Link
          href="https://www.linkedin.com/in/dtonys/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            textDecoration: 'none',
            color: 'inherit',
            '&:hover': { opacity: 0.7 },
          }}
        >
          <LinkedInIcon />
          <Typography>LinkedIn</Typography>
        </Link>
      </Stack>

      <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>
        Projects
      </Typography>

      <Stack direction="row" spacing={3}>
        <Link
          href="https://www.react-node-aws.com/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            textDecoration: 'none',
            color: 'inherit',
            '&:hover': { opacity: 0.7 },
          }}
        >
          <LaunchIcon fontSize="small" />
          <Typography>react-node-aws.com</Typography>
        </Link>

        <Link
          href="https://blog19.com/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            textDecoration: 'none',
            color: 'inherit',
            '&:hover': { opacity: 0.7 },
          }}
        >
          <LaunchIcon fontSize="small" />
          <Typography>blog19.com</Typography>
        </Link>
      </Stack>
    </Box>
  );
};

export { HomePage };
export default HomePage;
